import { Component, OnDestroy, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    styles: [`
        iframe.displayFrame {
            height: calc(100vh - 70px); 
            width: calc(100vw - 300px); 
            background-color: transparent; 
            border: 0px none transparent; 
            padding: 0px;
        }

        iframe.displayFrameSmall {
            height: calc(100vh - 70px); 
            width: calc(100vw); 
            background-color: transparent; 
            border: 0px none transparent; 
            padding: 0px;
        }
    `],
    template: `
        <iframe [class]="isSmall ? 'displayFrameSmall' : 'displayFrame'" src="https://attensa.com/emptyhome"></iframe>
    `
})
export class BrowseHomeComponent implements OnInit, OnDestroy {
    cleanupTime = new Subject<void>();
    isSmall: boolean;
    
    constructor(private media: MediaObserver) {}
    
    ngOnInit(): void {
        this.media.asObservable()
        .pipe(takeUntil(this.cleanupTime))
        .subscribe((mediaChanges: MediaChange[]) => this.isSmall = mediaChanges.reduce((prev, cur) => prev || cur.mqAlias === 'xs', false));
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}